export default __webpack_public_path__ + "static/media/sledstvennyij.138e027c.jpeg";